var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.linkComponent,
    {
      tag: "component",
      staticClass: "highlight-link",
      class: [
        _vm.getButtonType,
        _vm.getButtonStyle,
        _vm.getIconPosition,
        _vm.getButtonSize,
        _vm.getBlock,
      ],
      attrs: {
        href: _vm.url,
        to: { path: _vm.url },
        target: _vm.targetNewWindow,
        rel: _vm.buttonRel,
      },
      nativeOn: {
        click: function ($event) {
          return _vm.$emit("highlight-button-click")
        },
      },
    },
    [
      _vm.slotIconUsed
        ? [
            _c(
              "div",
              { staticClass: "icon-container" },
              [_vm._t("slotIcon")],
              2
            ),
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.hasIcon(_vm.icon)
        ? [_c("highlight-button-icons", { attrs: { icon: _vm.icon } })]
        : _vm._e(),
      _vm._v(" "),
      _vm.title ? _c("span", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }